import axios from '@/api/config';

const freeCourses = {
  pageList (data) {
    return axios.post(`${process.env.BASE_URL}/appTencentVideo/pageList`, data);
  },
  addAppTencentVideo (data) {
    return axios.post(`${process.env.BASE_URL}/appTencentVideo/addAppTencentVideo`, data);
  },
  updateAppTencentVideo (data) {
    return axios.put(`${process.env.BASE_URL}/appTencentVideo/updateAppTencentVideo`, data);
  },
  deleteAppTencentVideo (data) {
    return axios.delete(`${process.env.BASE_URL}/appTencentVideo/deleteAppTencentVideo`, { data: data });
  },
}

export default freeCourses;



// WEBPACK FOOTER //
// ./src/api/freeCourses.js